import React, { FC } from 'react';
import classNames from 'classnames/bind';
import Flag from 'ui/CustomPhone/components/Flag';
import service from 'error-handler/functions/service';
import { IPhoneNumber } from 'ui/CustomPhone/types';
import styles from 'ui/CustomPhone/Phone.module.scss';

const cn = classNames.bind(styles);

interface ICountry extends IPhoneNumber {
  activeISO?: string;
  isoChangeHandler: (props: IPhoneNumber) => void;
}

const Country: FC<ICountry> = ({ iso, name, countryCode, mask, activeISO, isoChangeHandler }): React.ReactElement => {
  return (
    <li
      onClick={() => service({ iso, name, countryCode, mask })('isoChangeHandler')(isoChangeHandler)}
      // className={`select__country${iso === activeISO ? ' select__country--active' : ''}`}
      className={cn('select__country', { 'select__country--active': iso === activeISO })}
    >
      <Flag code={countryCode.toLowerCase()} />

      <span className={cn('select__country-name')}>{name}</span>
      <span className={cn('select__country-iso')}>{iso}</span>
    </li>
  );
};

export default React.memo(Country);
